<template>
	<nav-bar></nav-bar>
	<home-page></home-page>
	<introduction-page></introduction-page>
	<my-work-page></my-work-page>
	<my-blogs></my-blogs>
	<hire-me></hire-me>
	<Footer></Footer>
</template>

<script>
import NavBar from "./components/navbar/NavBar.vue";
import HomePage from "./components/routes/HomePage.vue";
import IntroductionPage from "./components/routes/IntroductionPage.vue";
import MyWorkPage from "./components/routes/MyWorkPage.vue";
import MyBlogs from "./components/routes/MyBlogs.vue";
import HireMe from "./components/hireMe/HireMe.vue";
import Footer from "./components/footer/Footer.vue";

export default {
	name: "App",
	components: {
		HomePage,
		IntroductionPage,
		MyWorkPage,
		MyBlogs,
		HireMe,
		NavBar,
		Footer,
	},
};
</script>

<style>
html,
body {
	overflow: visible;
}
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
	width: 100%;
}
</style>
